<div
  class="flex flex-col items-center gap-6 md:gap-12 p-6 md:p-10 bg-neutrals-0 rounded-3xl w-full"
>
  <div class="flex flex-col items-center gap-4 md:gap-6 w-full text-center">
    <ui-illustrative-icon
      name="i-order-received"
      size="m"
      m-size="s"
    ></ui-illustrative-icon>
    <ui-paragraph
      type="p20"
      font-weight="semibold"
      text-color="neutrals-900"
      content="Confirma el registro de la compra"
    />
    <div
      class="flex flex-col gap-4 text-neutrals-700 text-[16px] leading-6 text-center"
    >
      <p>
        Al confirmar, el
        <span class="font-semibold">Registro #{{ order.orderNumber }}</span>
        pasará al estado
        <span class="font-semibold">ACEPTADO</span>
        y se moverá a
        <span class="font-semibold">Historial</span>.
      </p>
      <p>Recuerda que está acción es irreversible.</p>
    </div>
  </div>

  <digicem-receipt-dropzone
    *ngIf="!hasReceipt"
    class="w-full"
    [serverError]="serverError"
    (fileSelected)="onFileSelected($event)"
  ></digicem-receipt-dropzone>

  <ui-alert
    *ngIf="!hasReceipt && apiError"
    type="critical"
    [message]="apiError"
  ></ui-alert>

  <div class="flex flex-col gap-2 w-full">
    <ui-button
      type="primary"
      responsive="false"
      size="lg"
      button-text="Sí, aceptar"
      [enabled]="hasValidInput"
      [isLoading]="isLoading"
      (click)="onConfirm()"
    ></ui-button>
    <ui-button
      type="secondary"
      responsive="false"
      size="lg"
      button-text="Ahora no"
      [enabled]="!isLoading"
      [isLoading]="false"
      (click)="onCancel()"
    ></ui-button>
  </div>
</div>
